// @flow
const isUndefined = (value: any): boolean => value === undefined

export default isUndefined
